import React from 'react';
// components
import DateText from 'modules/emergencies/components/ui/texts/DateText';
import DateColumn from 'modules/emergencies/components/ui/columns/dateColumn';
import DateRow from 'modules/emergencies/components/ui/rows/dateRow';

const TicketsListTableDateRow = ({ ticketsGroupedByDay }) => {
  return (
    <DateRow key={ticketsGroupedByDay.label}>
      <DateColumn>
        <DateText>
          {ticketsGroupedByDay.label} ({ticketsGroupedByDay.tickets.length} tickets)
        </DateText>
      </DateColumn>
    </DateRow>
  );
};

export default TicketsListTableDateRow;
